import React from 'react';
import './sidebar.css';
import { useEffect,useState } from 'react';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
  CDBSidebarFooter,
  CDBIcon,
} from 'cdbreact';
import { BsBoxArrowRight  } from 'react-icons/bs';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import baseUrl from '../../../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const SideBar = () => {
  const navigate = useNavigate();
  function logout() {
    sessionStorage.clear();
    navigate("/login");
  }
  const [show, setShow] = useState(false);
  const [reset, setReset] = useState(false);
  const handleresetCloth = () => setReset(false);
  const handleresetShow = () => setReset(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [pass , setPass] = useState({
     password: ''
   });
  const session_username = sessionStorage.getItem("name");
  const session_email = sessionStorage.getItem("email");
  const session_token = sessionStorage.getItem("token");
  useEffect(() => { 
    axios.defaults.headers.common = {
      Authorization: `Bearer ${session_token}`,
    };


  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPass((prevData) => ({ ...prevData, [name]: value }));
  }; 
  const handlesave = () =>{
    axios.put(`${baseUrl}/user/password`, { password: pass.password })
    .then((response) => {
      console.log('Password saved successfully', response.data);
      handleresetCloth();
      toast.success('Password saved successfully');
    })
    .catch((error) => {
      console.error('Error saving password', error);
      toast.error('Error on saving password');
      // Handle errors if needed
    });
  } 
  return (
    <>
    <Modal size="md" show={reset} onHide={handleresetCloth} animation={true}>
      <Modal.Header>
       <p>Please Enter New Password you will be remeber !</p>
      </Modal.Header>
      <Modal.Body>
        <input type='text' onChange={handleInputChange} value={pass.password}  className='form-control' placeholder='Enter new password' name='password'/>
      </Modal.Body>
      <center>
        <button onClick={handlesave} style={{backgroundColor: 'white', border: '2px solid #EAECEE ', padding: '5px', margin:'5px', width: 90, borderRadius: '15px'}}>Save</button>

      </center>
    </Modal>
    <Modal size="sm" show={show} onHide={handleClose} animation={true} dialogClassName="modal-profile">
      <Modal.Header>
        <h5>Profile</h5>
      </Modal.Header>
      <Modal.Body>
        <div class="">
          <small>Name</small>
          <br/>
         <strong>{session_username}</strong>
        </div>
        <div class="">
          <small class="text-wrapper">Email</small>
          <br/>
         <p style={{
fontWeight: 'bold',
fontSize: 18,
overflow:' hidden',
whiteSpace: 'nowrap',
textOverflow: 'ellipsis',
maxWidth: '200px'
         }}>{session_email}</p>
        </div>
      </Modal.Body>
      <center>
        <button onClick={()=>{
          setShow(false);
          setReset(true);

        }}   style={{backgroundColor: 'white', border: '2px solid #EAECEE ', padding: '5px', margin:'5px', borderRadius: '15px'}}>Reset Password</button>

      </center>
    </Modal>
    <CDBSidebar className='mysidebar' textColor="#333"  maxWidth='70px' backgroundColor="#fff" style={{boxShadow: '3px 0px 10px 0px rgba(0, 0, 0, 0.25)'}}>
        {/* <CDBSidebarMenuItem icon='bars' style={{paddingTop: '10px'}}>
      
        </CDBSidebarMenuItem>  */}
           <ToastContainer />
        <CDBSidebarContent>
          <CDBSidebarMenu onClick={handleShow}>
            <CDBSidebarMenuItem icon='user'>

            </CDBSidebarMenuItem>

          </CDBSidebarMenu>
          {/* <CDBSidebarMenu>

            <CDBSidebarMenuItem icon="search"></CDBSidebarMenuItem>

          </CDBSidebarMenu> */}

        </CDBSidebarContent>

        <CDBSidebarFooter style={{ textAlign: 'center' }}>
          <div
          type="button"
            className="sidebar-btn-wrapper"
            style={{ padding: '5px 5px', backgroundColor: '#EF7D7D', color: 'white', height: '40px', margin: '16px 20px', borderRadius: '10%' }}
            onClick={logout}
          >
            <BsBoxArrowRight size={20} />
            {/* <CDBSidebarMenuItem icon='arrow-right'></CDBSidebarMenuItem> */}
          </div>
        </CDBSidebarFooter>
      </CDBSidebar></>
  );
};

export default SideBar;